// extracted by mini-css-extract-plugin
module.exports = {"container":"covid-information-module--container--3P8ET","title":"covid-information-module--title--32rUs"};